import { createContext, useCallback, useContext, useState } from "react"
import PWAdminEnabled from "./PWAdminEnabled"

type PWAdminCmdKContextValue = {
  hintsActive: boolean
  setHintsActive: (active: boolean) => void
  pwAdminEnabled: boolean
  checkPWAdminEnabled: () => void
}

export const PWAdminCmdKContext = createContext<PWAdminCmdKContextValue>(
  {} as PWAdminCmdKContextValue
)

export function usePWAdminCmdKContext() {
  const context = useContext(PWAdminCmdKContext)
  if (!context) {
    throw new Error(
      "usePWAdminCmdKContext must be used within a PWAdminCmdKProvider"
    )
  }
  return context
}

export function PWAdminCmdKContextProvider({
  children
}: {
  children: React.ReactNode
}) {
  const [hintsActive, setHintsActive] = useState(false)
  const [pwAdminEnabled, setPWAdminEnabled] = useState(false)
  const [checkPWAdminEnabled, setCheckPWAdminEnabled] = useState(false)

  const handleCheckPWAdminEnabled = useCallback(() => {
    setCheckPWAdminEnabled(true)
  }, [])

  return (
    <PWAdminCmdKContext.Provider
      value={{
        hintsActive,
        setHintsActive,
        pwAdminEnabled,
        checkPWAdminEnabled: handleCheckPWAdminEnabled
      }}
    >
      {children}
      {checkPWAdminEnabled && (
        <PWAdminEnabled onPWAdminEnabled={setPWAdminEnabled} />
      )}
    </PWAdminCmdKContext.Provider>
  )
}
